export default "__VITE_ASSET__22cb8007__"